module.exports = __webpack_public_path__ + "img/aa826a6.jpg";